export const pad2 = (n) => String(n).padStart(2, "0");

export const todayKey = () => {
  const d = new Date();
  return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
};

export const timeToMin = (t) => {
  if (!t) return 0;
  const [h, m] = t.split(":").map(Number);
  return h * 60 + m;
};

export const minToTime = (mins) =>
  `${pad2(Math.floor(mins / 60))}:${pad2(mins % 60)}`;

export const format12h = (t) => {
  if (!t) return "";
  const [hh, mm] = t.split(":").map(Number);
  const ap = hh >= 12 ? "PM" : "AM";
  const h12 = hh % 12 === 0 ? 12 : hh % 12;
  return `${pad2(h12)}:${pad2(mm)} ${ap}`;
};

export const buildSlots = (startMin, endMin, stepMin) => {
  const out = [];
  for (let m = startMin; m < endMin; m += stepMin) {
    out.push({
      startMin: m,
      endMin: m + stepMin,
      label: `${format12h(minToTime(m))} - ${format12h(
        minToTime(m + stepMin)
      )}`,
      key: `${m}`,
    });
  }
  return out;
};

export const isOverlap = (aStart, aEnd, bStart, bEnd) =>
  aStart < bEnd && bStart < aEnd;

// เพิ่มท้ายไฟล์ timeUtils.js
export const formatDateDMY = (dateKey) => {
  if (!dateKey) return "";
  const [y, m, d] = String(dateKey).split("-");
  if (!y || !m || !d) return String(dateKey);
  return `${d}/${m}/${y}`;
};

